import React, { useEffect, useState } from 'react';
import { Icon } from '@ampol/design-system';
import './ampol-card-alert-bar.scss';

const cookieName = 'ampol-card-alert-dismissed';

export const isClient = !(typeof window === 'undefined' || typeof window?.document === 'undefined');
/**
 * Describe component here
 * @param props
 */
const AmpolCardAlertBar = ({ message, id, colour = 'red', defaultHidden = true, isActive = true, handleCloseFn }) => {
  if (!isActive) return null;

  // SSG/SSR compat: must always start as same state or will cause hydration error
  const [isHidden, setIsHidden] = useState(defaultHidden);

  const handleClose = () => {
    setIsHidden(true);

    const oneDay = 24 * 60 * 60 * 1000;
    const expireTime = new Date(Date.now() + oneDay).toUTCString();

    document.cookie = `${cookieName}=${id}; expires=${expireTime}; path=/`;
    handleCloseFn?.();
  };

  useEffect(() => {
    if (isClient) {
      const hasCookie = document.cookie.includes(`${cookieName}=${id}`);

      setIsHidden(hasCookie);
    }
  }, [isActive]);

  return (
    <div
      aria-atomic="true"
      aria-live="polite"
      className={`ampol-card-alert-bar ampol-card-alert-bar--${colour} ${isHidden ? 'ampol-card-alert-bar--hidden' : '' }`}
      data-testid="AlertBar"
    >
      <div className={'ampol-card-alert-bar__inner'}>
        <Icon className={'ampol-card-alert-bar__icon'} size={24} url={'/icons/icon-alert-white.svg'} />
        <div className={'ampol-card-alert-bar__message'}>{message}</div>
        <button
          onClick={handleClose}
          aria-label="close alert notification"
          className={'ampol-card-alert-bar__btnclose'}
          type="button"
        >
          <Icon size={24} url={'/icons/icon-alert-close.svg'} />
        </button>
      </div>
    </div>
  );
};

export default AmpolCardAlertBar;
